import { render, staticRenderFns } from "./lookproblemDialog.vue?vue&type=template&id=a7ae8de4&scoped=true"
import script from "./lookproblemDialog.vue?vue&type=script&lang=js"
export * from "./lookproblemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ae8de4",
  null
  
)

export default component.exports